import darkLogo from 'assets/logo-white.png';
import lightLogo from 'assets/logo-black.png';
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link to="/" className="inline-block rounded-xl">
      {/* Light mode logo */}
      <img
        src={lightLogo}
        alt="Ashita Logo Light"
        className="h-20 block dark:hidden transition-opacity duration-300"
      />
      {/* Dark mode logo */}
      <img
        src={darkLogo}
        alt="Ashita Logo Dark"
        className="h-20 hidden dark:block transition-opacity duration-300"
      />
    </Link>
  );
};
